'use strict';

/**
 * Utility functions fabric.js related.
 */

module.exports = {
    /**
     * Calculates the width of the text in pixels for the specified font and size string  and the specified fabricjs canvas.
     *
     * @param fabricCanvas
     * @param text
     *
     * @return width of text in pixels.
     */
    measureText: function (fabricCanvas, fontString, text) {
        var ctx = fabricCanvas.getContext();
        ctx.font = fontString;
        return ctx.measureText(text).width;
    }
};

